@if (loaderService.isLoading$| async) {
<div class="loader-overlay">
  <div class="loader" role="status" aria-label="Loading">
    <div class="mark">
      <svg viewBox="0 0 102 112" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <clipPath id="jClip">
            <path
              d="M101.349 60.082C101.349 89.9098 82.3971 111.663 50.5918 111.663C21.0936 111.663 0 94.0296 0 61.4004H21.4229C21.4229 81.1757 30.9813 91.2285 50.5918 91.2285C70.3671 91.2285 79.5957 77.5502 79.5957 60.082V20.2695H44.8242V0H101.349V60.082Z"
            />
          </clipPath>
          <linearGradient id="gloss" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stop-color="#fff" stop-opacity="0" />
            <stop offset="0.5" stop-color="#fff" stop-opacity="0.65" />
            <stop offset="1" stop-color="#fff" stop-opacity="0" />
          </linearGradient>
        </defs>

        <!-- Solid J base — always fully visible -->
        <path
          class="j-base"
          d="M101.349 60.082C101.349 89.9098 82.3971 111.663 50.5918 111.663C21.0936 111.663 0 94.0296 0 61.4004H21.4229C21.4229 81.1757 30.9813 91.2285 50.5918 91.2285C70.3671 91.2285 79.5957 77.5502 79.5957 60.082V20.2695H44.8242V0H101.349V60.082Z"
        />

        <!-- Sweeping gloss, clipped to the J shape -->
        <g clip-path="url(#jClip)">
          <rect class="shine" x="-30" y="-20" width="46" height="160" fill="url(#gloss)" />
        </g>

        <!-- Center keyhole -->
        <path
          class="keyhole"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M50.6738 52.8301C54.7057 52.8301 57.9745 56.099 57.9746 60.1309C57.9746 63.0836 56.2212 65.6254 53.6992 66.7754V74.0469C53.6992 75.7174 52.3453 77.072 50.6748 77.0723C49.0041 77.0723 47.6494 75.7176 47.6494 74.0469V66.7754C45.1275 65.6254 43.374 63.0836 43.374 60.1309C43.3742 56.0992 46.6422 52.8303 50.6738 52.8301Z"
        />
      </svg>
    </div>

    <div class="caption">
      <span>Loading</span>
      <span class="dots"><i></i><i></i><i></i></span>
    </div>
  </div>
</div>
}
